import { Injectable } from '@angular/core';
import { getJwtCartId, isJwtWithCartIdUsable } from 'src/app/shared/utils/jwt-token.utils';

@Injectable({ providedIn: 'root' })
export class CartSessionTokenService {
  private readonly KEY = 'cart_access_token';

  constructor() {
    this.clearLegacySharedStorage();
  }

  set(token: string): void {
    try {
      sessionStorage.setItem(this.KEY, token);
    } catch {
      // ignore storage errors
    }

    this.clearLegacySharedStorage();
  }

  get(): string | null {
    try {
      return sessionStorage.getItem(this.KEY);
    } catch {
      return null;
    }
  }

  clear(): void {
    try {
      sessionStorage.removeItem(this.KEY);
    } catch {
      // ignore storage errors
    }

    this.clearLegacySharedStorage();
  }

  has(): boolean {
    return !!this.get();
  }

  getCartId(): string | null {
    return getJwtCartId(this.get());
  }

  hasUsableCartId(): boolean {
    return isJwtWithCartIdUsable(this.get());
  }

  private clearLegacySharedStorage(): void {
    try {
      localStorage.removeItem(this.KEY);
    } catch {
      // ignore storage errors
    }
  }
}
